import './PageActionsRow.scss';
import React from 'react';

export const PageActionsRow = ({ children, leftContent }) => (
    <div className={'page-actions-row'}>
        <div className={'left-absolute-content'}>{leftContent}</div>
        {children}
    </div>
);
